"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.DeleteOfferItemEvent = void 0;
const Name = exports.Name = 'delete-offer-item';
const DeleteOfferItemEvent = exports.DeleteOfferItemEvent = Name;
